/**
 * Segmented control used to switch between the views of a list page.
 * `options` maps the visible label to the value the page filters by.
 */
export const SmallSwitchMenu = ({ options, selectmenu, setselectedmenu }) => {
  return (
    <div className="main-navigation-switch mb-4">
      <div className="employee-navigation inline-flex w-fit max-w-full flex-wrap gap-1 rounded-xl border border-slate-200 bg-slate-100 p-1">
        {Object.keys(options)?.map((e) => {
          const isActive = selectmenu === e;
          return (
            <button
              key={e}
              id={e}
              type="button"
              aria-pressed={isActive}
              onClick={() => setselectedmenu(e)}
              className={`rounded-lg px-4 py-1.5 text-sm font-medium transition focus:outline-none focus-visible:ring-2 focus-visible:ring-sky-500 ${
                isActive
                  ? 'bg-white text-sky-700 shadow-sm'
                  : 'text-slate-600 hover:bg-white/60 hover:text-slate-900'
              }`}
            >
              {e}
            </button>
          );
        })}
      </div>
    </div>
  );
};
